var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"flex-item float-right mt-3",class:_vm.centralize ? 'mx-auto' : 'mr-md-3 mb-n3',attrs:{"label":_vm.label,"input-value":_vm.model == 'A'},on:{"change":function (val) { return _vm.model = val ? 'A' : 'I'; }}})}
var staticRenderFns = []

export { render, staticRenderFns }